<template>
<div class="foot">
  <div class="contact">
    <div class="c-box">
      <div class="c-zw">联系我们</div>
      <div class="c-hx"></div>
      <div class="c-yw">Contact us</div>
      <div class="hx"></div>
      <div class="item">
        <div class="i-con" v-for="(item,index) in navigation">
<!--          <div class="icon">-->
<!--            <img :src="item.icon" alt="" class="i-img" :style="{width:item.width,height:item.height,marginTop:item.left,marginLeft:item.right}">-->
<!--          </div>-->
          <div class="title">{{item.name}}</div>
          <div class="text" v-for="(subItem,subIndex) in item.arr" :style="{width:item.name=='联系方式'?'200px':'',textAlign:item.name=='联系方式'?'left':''}" @click="tz(subItem.path)">{{subItem.name}}</div>
<!--          <div class="text" v-if="item.title==='电话'" :style="{marginTop: '0px'}">83330900</div>-->
        </div>
      </div>
    </div>
  </div>
  <div class="ba">
    <div class="b-con">@copy 2022 常州苏态安全环保科技有限公司 备案号：苏ICP备2022038941号-1</div>
  </div>
</div>
</template>

<script>
export default {
  name: "Foot",
  data(){
    return{
      navigation:[
        {
          name:'公司概况',
          arr:[
            {
              name:'公司介绍',
              path:'./Introduce'
            },
            // {
            //   name:'业务范围',
            //   path:'./pubList?index='+1
            // },
            {
              name:'文件公示',
              path:'./docList'
            },
            {
              name:'公司资质',
              path:'./Company'
            },
            // {
            //   name:'联系方式',
            //   path:'./Phone'
            // },
          ]
        },
        {
          name:'业务范围',
          arr:[
            {
              name:'安全',
              path:'./pubList?index='+1
            },
            {
              name:'环境',
              path:'./pubList?index='+2
            },
            {
              name:'职业卫生',
              path:'./pubList?index='+3
            },
          ]
        },
        {
          name:'联系方式',
          arr:[
            {
              name:'电话：15061136532',
            },
            {
              name:'座机：0519-83330900',
            },
            // {
            //   name:'官方网址：http://www.sutaihuanbao.com',
            // },
          ]
        }
      ],
      list:[
        {
          icon:require('@/assets/foot/phone.jpg'),
          width:'37.5px',
          height:'37.5px',
          left:'13px',
          right:'12px',
          title:'电话',
          text:'15061136532'
        },
        {
          icon:require('@/assets/foot/address.jpg'),
          width:'31px',
          height:'41px',
          left:'11px',
          right:'16px',
          title:'地址',
          text:'常州市新北区科勒路1号'
        },
        {
          icon:require('@/assets/foot/email.jpg'),
          width:'34.5px',
          height:'27px',
          left:'18px',
          right:'15px',
          title:'邮箱',
          text:'sutaihuanbao@163.com'
        }
      ],
    }
  },
  methods:{
    tz(name){
      console.log(name)
      this.$router.push({path:''+name+''})
    }
  }
}
</script>

<style scoped lang="scss">
.foot{
  width: 100vw;
  //margin-top: 150px;
  bottom: 0;
  .contact{
    width: 100vw;
    height: 489px;
    //position: fixed;
    display: flex;
    bottom: 102px;
    //background: #239584;
    background: #333333;
    .c-box{
      max-width: 1318px;
      min-width: 1180px;
      height: auto;
      margin: 90px auto 65px;
      .c-zw{
        width: 125px;
        height: 42px;
        //position: absolute;
        margin-left: 8px;
        font-weight: 700;
        font-size: 30px;
        line-height: 42px;
        color: #FFFFFF;
      }
      .c-hx{
        width: 135px;
        height: 7px;
        background: rgba(29, 181, 161, 0.72);
        margin-top: -11px;
      }
      .c-yw{
        width: 82px;
        height: 28px;
        margin-top: -20px;
        margin-left: 151px;
        font-weight: 400;
        font-size: 16px;
        line-height: 28px;
        color: #FFFFFF;
      }
      .hx{
        width: 1330px;
        height: 0;
        margin-top: 52px;
        border: 1px solid #FFFFFF;
      }
      .item{
        max-width: 1228px;
        min-width: 1180px;
        height: auto;
        display: flex;
        flex-flow: row nowrap;
        justify-content: space-between;
        margin:10px auto 0;
        text-align: center;
        .i-con{
          margin:0 auto;
          display: flex;
          flex-flow: column;
          align-items: center;
          .icon{
            width: 64px;
            height: 64px;
            background: #FFFFFF;
            border-radius: 50%;
            .i-img{
              object-fit: fill;
              margin: 0 auto;
            }
          }
        }
        .title{
          width: 100px;
          height: 28px;
          font-weight: 700;
          font-size: 24px;
          line-height: 28px;
          color: #FFFFFF;
          margin-top: 16px;
          align-items: center;
        }
        .text{
          width: 300px;
          height: 28px;
          font-weight: 700;
          font-size: 18px;
          line-height: 28px;
          color: #FFFFFF;
          margin-top: 15px;
          cursor: pointer;
        }
      }
    }
  }
  .ba{
    width: 100vw;
    height: 102px;
    background: #333333;
    //position: fixed;
    //bottom: 0;
    display: flex;
    .b-con{
      width: 542px;
      height: 18px;
      font-weight: 400;
      font-size: 14px;
      line-height: 18px;
      color: #FFFFFF;
      margin: 42px auto;
    }
  }
}
</style>
